(() => {
  class HxRangeCarousel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController(); const signal = this.controller.signal;
      this.track = this.querySelector('[data-range-track]');
      this.cards = [...this.track.children];
      this.goalButtons = [...(this.closest('.hx-story-content')?.querySelectorAll('[data-range-goal]') || [])];
      this.goalButtons.forEach(button => button.addEventListener('click', () => this.filterGoal(button.dataset.rangeGoal), {signal}));
      this.autoplay = this.dataset.autoplay !== 'false';
      this.pauseButton = this.querySelector('[data-range-pause]');
      this.motion = matchMedia('(prefers-reduced-motion:reduce)');
      this.story = this.closest('hx-range-story');
      this.story?.addEventListener('hx:story-visibility', () => this.schedule(),{signal});
      this.paused = this.motion.matches; this.hovered = false; this.focused = false; this.visible = false; this.position = 0;
      if (this.track.children.length < 2) return;
      this.querySelector('.hx-range-controls').hidden = false;
      this.updatePause();
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { this.hovered = true; this.schedule(); } },{signal});
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); },{signal});
      this.addEventListener('focusin', event => { this.focused = this.track.contains(event.target); this.schedule(); },{signal});
      this.addEventListener('focusout', () => queueMicrotask(() => { this.focused = this.track.contains(document.activeElement); this.schedule(); }),{signal});
      this.track.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') { this.paused = true; this.updatePause(); this.schedule(); } },{signal});
      this.track.addEventListener('wheel', e => { if (Math.abs(e.deltaX) > 1) { this.paused = true; this.updatePause(); this.schedule(); } },{passive:true,signal});
      this.pauseButton?.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); },{signal});
      this.querySelectorAll('[data-range-step]').forEach(button => button.addEventListener('click', () => this.step(Number(button.dataset.rangeStep)),{signal}));
      this.track.addEventListener('keydown', e => { if (e.target !== this.track || !['ArrowLeft','ArrowRight'].includes(e.key)) return; e.preventDefault(); this.step(e.key === 'ArrowRight' ? 1 : -1); },{signal});
      document.addEventListener('visibilitychange', () => this.schedule(),{signal});
      this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.updatePause(); this.schedule(); },{signal});
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); },{threshold:.15});
      this.observer.observe(this);
      this.resize = new ResizeObserver(() => { this.position = this.track.scrollLeft; this.schedule(); }); this.resize.observe(this.track);
    }
    updatePause() {
      if (!this.pauseButton) return;
      this.pauseButton.setAttribute('aria-pressed',String(this.paused));
      this.pauseButton.setAttribute('aria-label',this.paused ? this.dataset.play : this.dataset.pause);
      this.pauseButton.querySelector('.hx-ui-icon path')?.setAttribute('d', this.paused ? 'm9 5 11 7-11 7Z' : 'M8 5v14M16 5v14');
      this.pauseButton.hidden = !this.autoplay || this.motion.matches;
    }
    filterGoal(goal) {
      cancelAnimationFrame(this.frame); this.last = null;
      const cards = this.cards.filter(card => goal === 'all' || card.dataset.hxGoals.trim().split(/\s+/).includes(goal));
      this.track.replaceChildren(...cards);
      this.track.scrollLeft = 0; this.position = 0;
      this.goalButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rangeGoal === goal)));
      this.querySelector('[data-range-count]').textContent = this.dataset.count.replace('[count]', String(cards.length));
      this.querySelector('.hx-range-controls').hidden = cards.length < 2;
      this.schedule();
    }
    stride() { const cards = this.track.children; return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0]?.getBoundingClientRect().width || 0; }
    step(direction) {
      if (this.track.children.length < 2) return;
      this.schedule();
      const width = this.stride();
      if (direction < 0 && this.track.scrollLeft < width) { this.track.prepend(this.track.lastElementChild); this.track.scrollLeft += width; }
      if (direction > 0 && this.track.scrollLeft + width >= this.track.scrollWidth - this.track.clientWidth) { this.track.append(this.track.firstElementChild); this.track.scrollLeft -= width; }
      this.track.scrollBy({left:direction * width,behavior:this.motion.matches ? 'instant' : 'smooth'});
    }
    schedule() {
      cancelAnimationFrame(this.frame); this.last = null;
      if (!this.autoplay || !this.isConnected || !this.visible || this.paused || this.hovered || this.focused || this.motion.matches || this.story?.hasAttribute('data-story-covering') || document.hidden || this.track.scrollWidth <= this.track.clientWidth + 1) return;
      this.position = this.track.scrollLeft;
      this.frame = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      const elapsed = this.last === null ? 0 : Math.min(time - this.last,64); this.last = time;
      this.position += elapsed * .028;
      const width = this.stride();
      if (width > 0 && this.position >= width) { this.track.append(this.track.firstElementChild); this.position -= width; }
      this.track.scrollLeft = this.position;
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); this.controller = null; this.observer?.disconnect(); this.resize?.disconnect(); }
  }
  if (!customElements.get('hx-range-carousel')) customElements.define('hx-range-carousel',HxRangeCarousel);
})();
